import React from 'react';
import {
    Card,
    CardContent,
    TextField,
    Typography,
} from '@mui/material';
import {theme} from '../../mui/theme';

const styles = {
    inputFieldSpacing: {
        marginTop: 2.5,
    },
    zipInputField: {
        marginTop: 2.5,
        width: '140px',
    },
    cityInputField: {
        marginTop: 2.5,
        marginLeft: 2,
        width: 'calc(100% - 156px)',
    },
    sectionDivider: {
        marginTop: 4,
        marginBottom: 2.5,
    },
    baseData: {
        flex: 3,
        [theme.breakpoints.up('sm')]: {
            marginRight: 2,
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
            marginBottom: 2,
        },
    },
};

interface StammdatenTabProps {
    readOnly?: boolean;
    restaurantName: string;
    setRestaurantName: (v: string) => void;
    companyName: string;
    setCompanyName: (v: string) => void;
    billingStreet: string;
    setBillingStreet: (v: string) => void;
    billingZip: string;
    setBillingZip: (v: string) => void;
    billingCity: string;
    setBillingCity: (v: string) => void;
    contactPerson: string;
    setContactPerson: (v: string) => void;
    street: string;
    setStreet: (v: string) => void;
    zip: string;
    setZip: (v: string) => void;
    city: string;
    setCity: (v: string) => void;
    phone: string;
    setPhone: (v: string) => void;
    email: string;
    setEmail: (v: string) => void;
    web: string;
    setWeb: (v: string) => void;
}

const StammdatenTab: React.FC<StammdatenTabProps> = (props) => {
    const readOnly = props.readOnly ?? false;
    return (
        <Card sx={styles.baseData}>
            <CardContent>
                <TextField
                    label={'Gastroname'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    value={props.restaurantName}
                    onChange={event => props.setRestaurantName(event.target.value)}
                />
                <TextField
                    label={'Name des Betriebes (Betreiber)'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.inputFieldSpacing}
                    value={props.companyName}
                    onChange={event => props.setCompanyName(event.target.value)}
                />

                <Typography variant={'body1'} sx={styles.sectionDivider}>
                   Rechnungsadresse
                </Typography>

                <TextField
                    label={'Straße'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    value={props.billingStreet}
                    onChange={event => props.setBillingStreet(event.target.value)}
                />
                <TextField
                    label={'Postleitzahl'}
                    variant={'outlined'}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.zipInputField}
                    value={props.billingZip}
                    onChange={event => props.setBillingZip(event.target.value)}
                />
                <TextField
                    label={'Stadt'}
                    variant={'outlined'}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.cityInputField}
                    value={props.billingCity}
                    onChange={event => props.setBillingCity(event.target.value)}
                />

                <Typography variant={'body1'} sx={styles.sectionDivider}>
                    Kontaktdaten
                </Typography>

                <TextField
                    label={'Kontaktperson'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    value={props.contactPerson}
                    onChange={event => props.setContactPerson(event.target.value)}
                />
                <TextField
                    label={'Straße'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.inputFieldSpacing}
                    value={props.street}
                    onChange={event => props.setStreet(event.target.value)}
                />
                <TextField
                    label={'Postleitzahl'}
                    variant={'outlined'}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.zipInputField}
                    value={props.zip}
                    onChange={event => props.setZip(event.target.value)}
                />
                <TextField
                    label={'Stadt'}
                    variant={'outlined'}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.cityInputField}
                    value={props.city}
                    onChange={event => props.setCity(event.target.value)}
                />
                <TextField
                    label={'Telefon'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.inputFieldSpacing}
                    value={props.phone}
                    onChange={event => props.setPhone(event.target.value)}
                />
                <TextField
                    label={'E-Mail'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.inputFieldSpacing}
                    value={props.email}
                    onChange={event => props.setEmail(event.target.value)}
                />
                <TextField
                    label={'Internet'}
                    variant={'outlined'}
                    fullWidth={true}
                    size={'small'}
                    disabled={readOnly}
                    sx={styles.inputFieldSpacing}
                    value={props.web}
                    onChange={event => props.setWeb(event.target.value)}
                />
            </CardContent>
        </Card>
    );
};

export default StammdatenTab;
